import { ProductModule } from '@erp/shared-types';
import {
  CloudIcon,
  DatabaseIcon,
  ShoppingBagIcon,
  type Icon,
} from '@phosphor-icons/react';

/** The ERP integrations surfaced on the "ERP" settings page. */
export type ErpKey = 'famous' | 'oracle-fusion' | 'oracle-ebs';

export interface ErpDefinition {
  key: ErpKey;
  module: ProductModule;
  name: string;
  description: string;
  Icon: Icon;
  /** Tailwind classes for the icon tile / glyph when the module is enabled. */
  enabledTile: string;
  enabledIcon: string;
}

export const ERPS: ErpDefinition[] = [
  {
    key: 'famous',
    module: ProductModule.FAMOUS_INTEGRATION,
    name: 'Famous',
    description: 'Connect with Famous ERP system',
    Icon: ShoppingBagIcon,
    enabledTile: 'bg-orange-100 dark:bg-orange-900/20',
    enabledIcon: 'text-orange-600 dark:text-orange-400',
  },
  {
    key: 'oracle-fusion',
    module: ProductModule.ORACLE_FUSION_INTEGRATION,
    name: 'Oracle Fusion',
    description: 'Connect with Oracle Fusion Cloud ERP',
    Icon: CloudIcon,
    enabledTile: 'bg-blue-100 dark:bg-blue-900/20',
    enabledIcon: 'text-blue-600 dark:text-blue-400',
  },
  {
    key: 'oracle-ebs',
    module: ProductModule.ORACLE_EBS_INTEGRATION,
    name: 'Oracle EBS',
    description: 'Connect with Oracle E-Business Suite',
    Icon: DatabaseIcon,
    enabledTile: 'bg-violet-100 dark:bg-violet-900/20',
    enabledIcon: 'text-violet-600 dark:text-violet-400',
  },
];

export const ERP_KEYS: ErpKey[] = ERPS.map((e) => e.key);

export function getErpByKey(key: string): ErpDefinition | undefined {
  return ERPS.find((e) => e.key === key);
}
